import React, { FC } from "react";
// import Logo from "shared/Logo/Logo";
import LogoLArge from "shared/Logo/LogoLarge";

import MenuBar from "shared/MenuBar/MenuBar";
// import SwitchDarkMode from "shared/SwitchDarkMode/SwitchDarkMode";
// import LangDropdown from "./LangDropdown";
// import NotifyDropdown from "./NotifyDropdown";
import AvatarDropdown from "./AvatarDropdown2";
// import CurrencyDropdown from "./CurrencyDropdown";
// import DropdownTravelers from "./DropdownTravelers";
// import { Link } from "react-router-dom";
import HeroSearchForm2MobileFactory from "components/HeroSearchForm2Mobile/HeroSearchForm2MobileFactory";
// import ButtonSquareFull from "shared/Button/ButtonSqareFull";
// import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import texture from "images/bg_Texture5.png";
import { useAuth0 } from "@auth0/auth0-react";


export interface MainNav3Props {
  className?: string;
}

const MainNav3: FC<MainNav3Props> = ({ 
    className = "",
}) => {
    const { loginWithRedirect, logout } = useAuth0();
    
    function gotoLogin() {
      }
  
    const logoutWithRedirect = () =>{
       logout({ logoutParams: { returnTo: window.location.origin }})
    // console.log("le di");
    };

    const {user, isAuthenticated} = useAuth0();
    // console.log(user);

   

  return (
    <div className="relative">
      <div className={`absolute left-0 top-0  ${className} opacity-50  w-full  h-[97px] z-0`} style={{
        backgroundImage: `url(${texture})`, // Set the background image using the 'texture' variable
        backgroundSize: 'auto', // The image will display at its original size
        backgroundRepeat: 'repeat', // The image will repeat both horizontally and vertically
        }}>
     </div>
        <div className="ml-[70px] mr-[100px] py-4 lg:py-5 relative flex justify-between items-center"> {/* Use Flexbox */}
            <div className="hidden md:flex justify-start flex-1 items-center space-x-3 sm:space-x-8 lg:space-x-10">
            <div className="flex justify-left  flex-1 pl-[10px]"> {/* Centering the logo horizontally and vertically */}
                <LogoLArge />
            </div>
            </div>

            <div className="lg:hidden flex-[3] max-w-lg !mx-auto md:px-3">
            <HeroSearchForm2MobileFactory />
            </div>

            <div className="hidden md:flex flex-shrink-0 items-center justify-end flex-1 lg:flex-none text-neutral-700">
         
             <button className="text-sm font-semibold ">BLOG</button>
             <button className="text-sm font-semibold  px-[35px]" >ABOUT US</button>

            { !isAuthenticated && <button className="bg-[#00D3DB] rounded-md h-7 text-sm font-semibold text-[white] px-[19px]" onClick={() => loginWithRedirect()}>Log In</button>}
            { isAuthenticated && <AvatarDropdown logoutClick={logoutWithRedirect} />}

            <MenuBar />
            </div>
        </div>

</div>
  );
};

export default MainNav3;